export var stopPropagation = function stopPropagation(nativeEvent) {
  if (nativeEvent.stopPropagation) {
    nativeEvent.stopPropagation();
  } else {
    nativeEvent.cancelBubble = false;
  }
};